import select from "./select";
import timepicker from "./timepicker";
import datepicker from "./datepicker";

export default (component, content) => {
    let newContent = content;

    switch(component) {
        case 'wireui_select':
            newContent = select(content);
            break;
        case 'wireui_timepicker':
            newContent = timepicker(content);
            break;
        case 'wireui_datetime_picker':
            newContent = datepicker(content);
            break;
    }

    return newContent;
};
